var React = require('react');

function Podium (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M384 224l-22.22 240H86.22L64 224z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M400 464H48a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm32-320H113.68c6.2-30.29 29.85-54.3 61-61.55A47.72 47.72 0 0 0 208 96h64a48 48 0 0 0 0-96h-64a47.89 47.89 0 0 0-46.31 36C110.81 48.48 71.66 91.15 65 144H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16z","className":"fa-primary","key":2})]);
}

Podium.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Podium;

Podium.default = Podium;
